import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CryptoJS from 'crypto-js';
import { updateFirstlogin } from '@blade-sxp/login/api/index';
import { AccountModule } from '@blade-sxp/account/store/account';
const en = {
    titles: 'Please change your password the first time you log in',
    userName: 'User Name',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    updatePassword: 'Change Password',
    enterPass: 'Please enter password',
    passType: 'The password should be at least 8 characters, consisting of uppercase letters, lowercase letters, special characters, and digits',
    againPassword: 'Please enter password again',
    InconsistentPasswords: 'These two passwords do not match',
};
const zh = {
    titles: '首次登陆需修改密码',
    userName: '用户名',
    newPassword: '请输入新密码',
    confirmPassword: '请再次输入新密码',
    updatePassword: '修改密码',
    enterPass: '请输入密码',
    passType: '密码应该由至少8位大写字母，小写字母，特殊字符和数字组成',
    InconsistentPasswords: '两次密码不一致',
    againPassword: '请再次输入密码',
};
let default_1 = class default_1 extends Vue {
    langType;
    lang = en;
    oncePass = false;
    aginPass = false;
    ruleForm = {
        pass: '',
        checkPass: '',
    };
    get userName() {
        return AccountModule?.accountInfo?.user_name;
    }
    ;
    get userId() {
        return AccountModule?.accountInfo?.id || '';
    }
    get rules() {
        return {
            pass: [
                { required: true, validator: this.validatePass, trigger: 'change' }
            ],
            checkPass: [
                { required: true, validator: this.validateCheckPass, trigger: 'change' }
            ],
        };
    }
    validatePass(_, value, callback) {
        let regex = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$');
        if (value === '') {
            callback(new Error(this.lang.enterPass));
            this.oncePass = false;
        }
        else if (!regex.test(value)) {
            callback(new Error(this.lang.passType));
            this.oncePass = false;
        }
        else {
            if (this.ruleForm.checkPass !== '') {
                this.$refs.ruleForm.validateField('checkPass');
            }
            callback();
            this.oncePass = true;
        }
    }
    ;
    validateCheckPass(_, value, callback) {
        if (value === '') {
            callback(new Error(this.lang.againPassword));
            this.aginPass = false;
        }
        else if (value !== this.ruleForm.pass) {
            this.aginPass = false;
            callback(new Error(this.lang.InconsistentPasswords));
        }
        else {
            callback();
            this.aginPass = true;
        }
    }
    ;
    onLangType(newVal) {
        this.$refs['ruleForm'].resetFields();
        if (newVal === 'en') {
            this.lang = en;
        }
        else {
            this.lang = zh;
        }
    }
    encrypt(word) {
        const key = CryptoJS.enc.Utf8.parse('AADF5D8AA08A90539D8739B77B0CE994');
        let srcs = CryptoJS.enc.Utf8.parse(word);
        let encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.ZeroPadding });
        return encrypted.ciphertext.toString().toUpperCase();
    }
    updatePass() {
        const params = {
            userId: this.userId || '',
            newPassword: this.encrypt(this.ruleForm.pass),
            repeatNewPassword: this.encrypt(this.ruleForm.pass),
        };
        updateFirstlogin(params).then((res) => {
            this.back();
        });
    }
    submitChangePass() {
        this.$refs['ruleForm'].validate((valid) => {
            if (valid) {
                this.updatePass();
            }
            else {
                return false;
            }
        });
    }
    back() {
        this.$emit('backLogin');
    }
};
__decorate([
    Prop()
], default_1.prototype, "langType", void 0);
__decorate([
    Watch('langType')
], default_1.prototype, "onLangType", null);
default_1 = __decorate([
    Component({
        name: 'asideTitle',
        components: {},
    })
], default_1);
export default default_1;
